import React, { Component } from 'react'
import '../OnlineHelpPage.css'
import RealTimeCommunication_001 from './img/RealTimeCommunication_web_001.png'
import RealTimeCommunication_002 from './img/RealTimeCommunication_web_002.png'
import RealTimeCommunication_003 from './img/RealTimeCommunication_web_003.png'
import RealTimeCommunication_004 from './img/RealTimeCommunication_web_004.png'
import RealTimeCommunication_005 from './img/RealTimeCommunication_web_005.png'


export default class WebRealTimeCommunication extends Component {
  render() {
    return (
      <div className="main-window">
        <div className="main-window-title">即时通信_网页端</div>
        <div className="main-window-content">1、点击用户个人信息区域，出现下拉框，选择即时通信</div>
        <div className="main-window-content">2、在侧边栏消息列表中可查看目前的通信信息，点击具体消息，右侧出现具体聊天内容</div>
        <div className="main-window-content">3、点击左侧边栏的好友列表可查看现有好友，以及申请添加好友的列表</div>
        <div className="main-window-content">界面以实际交付为准</div>
        <img src={RealTimeCommunication_001} className="main-window-img"></img>
        <img src={RealTimeCommunication_002} className="main-window-img"></img>
        <img src={RealTimeCommunication_003} className="main-window-img"></img>
        <img src={RealTimeCommunication_004} className="main-window-img"></img>
        <img src={RealTimeCommunication_005} className="main-window-img"></img>
      </div>
    )
  }
}
